import { curry } from 'ramda';

export const getCategoryOrder = curry((isDesktop, category) => {
  const orderIndex = isDesktop ? 1 : 0;
  return category.order[orderIndex];
});

export const orderCategories = curry((isDesktop, categories) => {
  const boundGetCategoryIndex = getCategoryOrder(isDesktop);
  return categories.sort((categoryA, categoryB) => {
    return boundGetCategoryIndex(categoryA) - boundGetCategoryIndex(categoryB);
  });
});

export const divideCategoriesOnMobile = (categories) => {
  const halfOrMore = Math.ceil(categories.length / 2);
  const firstHalf = categories.slice(0, halfOrMore);
  const secondHalf = categories.slice(halfOrMore);

  return [firstHalf, secondHalf];
};
